// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-execution/shared/ExecutionSection.jsx

import React from "react";
import { Section } from "../../../design-system/components";

function displayValue(value, fallback = "") {
  if (value === null || value === undefined || value === "") return fallback;
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }
  return fallback;
}

function normalizeTone(tone) {
  const value = String(tone || "").trim().toLowerCase();

  if (value === "ok") return "success";
  if (value === "warn") return "warning";
  if (value === "danger") return "danger";
  if (value === "default") return "informational";
  return "neutral";
}

export default function ExecutionSection({
  title,
  description,
  badge,
  badgeTone = "default",
  children,
}) {
  return (
    <Section
      title={displayValue(title, "Section")}
      description={displayValue(description)}
      badge={badge ? displayValue(badge) : null}
      badgeTone={normalizeTone(badgeTone)}
      density="default"
      className="execution-section"
    >
      {children}
    </Section>
  );
}
